module.exports = __webpack_public_path__ + "static/zenresumes-c30697ffda241f4cb81b169f8f65251e.svg";